module.exports = __webpack_public_path__ + "img/gradient-blue-purple-pink.31593b5.jpg";